export default "__VITE_PUBLIC_ASSET__adc73980__"